import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { BlockTitle, BlockMore } from '../HomePage';
import apiClient from '../../_utils/axios';
import Store from 'store';
import RenderThumbs from './renderThumbs';
import { useHomePageContext } from '../../context/HomePageContext';
import { getStringByLang } from '../../libs/lang';

export const RecommendDesign = ({ interest_list, onGoFavori, ShowBasketModal, setStateAsync }) => {
  const { state } = useHomePageContext();
  const [data, setData] = useState([]);
  const history = useHistory();

  const getSuitDesign = useCallback(async () => {
    let product_list = [];

    if (Store.get('accessToken') === undefined) {
      // 회원 정보가 없을 때 기존 방식으로 처리
      const res = await apiClient.get(`/web/product?&page=1&size=15&type=top_picks`);

      product_list = res.data.data;
    } else {
      // 추천 기능 결과가 15개 미만일 때 기존 방식에서 나머지 채우기
      // ! 추천 기능 API 사용 X
      // const resRecommend = await apiClient.get(`/web/dagyom/recommend`);

      product_list = [];

      if (product_list.length < 15) {
        const res = await apiClient.get(`/web/product?&page=1&size=15&type=top_picks`);
        const addData = res.data.data;
        const repeatValue = res.data.data.length - product_list.length;
        for (let i = 0; i < repeatValue; i++) {
          product_list.push(addData[i]);
        }
      }
    }
    if (product_list.length >= 15) {
      setData(product_list);
    }
  }, [history]);

  useEffect(() => {
    getSuitDesign();
  }, [getSuitDesign]);

  const reSetData = async (newData) => {
    setData([...newData]);
  };

  const renderedTitle = useMemo(() => {
    return getStringByLang(state.config.main_title_2_ko, state.config.main_title_2_en, state.config.main_title_2_jp);
  }, [state.config]);

  const renderedThumbs = useMemo(() => {
    return (
      <RenderThumbs
        thumbList={data}
        interest_list={interest_list}
        largeCount={15}
        middleCount={12}
        middleSmallCount={6}
        mallCount={6}
        setData={reSetData}
        main_title={renderedTitle}
        onGoFavori={onGoFavori}
        ShowBasketModal={ShowBasketModal}
        setStateAsync={setStateAsync}
      />
    );
  }, [data, interest_list, renderedTitle, onGoFavori, ShowBasketModal, setStateAsync]);

  const handleAllDesignClick = () => {
    history.push('/design/all/all?sort=interest_count&order=descend');
  };

  return (
    <div style={{ marginTop: '7vw' }}>
      <BlockTitle>{renderedTitle}</BlockTitle>
      <BlockMore onClick={handleAllDesignClick} />
      {renderedThumbs}
    </div>
  );
};

export default RecommendDesign;
